<template>
<v-dialog v-model="dialog" width="920" max-height="600" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
        <v-card-title class="headline p-2">
            Service Details
            <v-spacer />
            <v-btn icon left @click="emitExit()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="6" class="pa-1">
                    <div class="important">Name</div>
                    <div class="regular">{{ item.name }}</div>
                </v-col>
                <v-col cols="6" class="py-1">
                    <div class="important">Slug</div>
                    <div class="regular">{{item.slug}}</div>
                </v-col>
                <v-col cols="3" class="py-1">
                    <div class="important">Color</div>
                    <v-row no-gutters align="center">
                        <v-avatar class="elevation-4" size="36" :style="{background: item.color}" />
                        <div class="regular px-2">{{item.color}}</div>
                    </v-row>
                </v-col>
                <v-col cols="9" class="py-1">
                    <div class="important">Description</div>
                    <div class="regular">{{item.description}}</div>
                </v-col>
            </v-row>

            <im-service-roles :service_id="item_id"></im-service-roles>

        </v-card-text>


        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" persistent width="320px">
            <v-card>
                <v-card-text class="pt-2">Are you sure you want to delete this service?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" :loading="loading_delete" @click="destroy()">Delete</v-btn>
                    <v-btn text color="grey" @click="delete_dialog=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--./delete dialog -->

        <v-card-actions>
            <v-btn dark class="mx-1" color="red" :loading="loading_delete" @click="delete_dialog = true">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mx-1" color="primary" @click="emitEdit()">Edit</v-btn>
            <v-btn text class="mx-1" @click="emitExit()">Cancel</v-btn>
        </v-card-actions>
    </v-card>

</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import IMTableHeader from '../../utils/IMTableHeader.vue';
import IMSortField from "../../utils/IMSortField.vue";
import IMServiceRoles from "./RolesTableCrud.vue";

export default {
    components: {
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-service-roles': IMServiceRoles,
    },

    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        item_id: [Number, String],

    },
    data() {
        return {
            // service
            item: defaults.service_item,

            role: {
                slug: '',
                name: '',
                description: ''
            },

            // modals
            loading_delete: false,
            delete_dialog: false,

            //table
            loading: true,



        }
    },
    watch: {
        item_id: {
            handler() {
                this.getItem();
            }
        },

    },
    created() {
        this.getItem();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getItem() {
            if(!this.item_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/services/' + this.item_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },


        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/services';

            // call delete endpoint
            this.$axios.delete(endpoint + '/' + this.item.id) // eslint-disable-next-line
                .then(response => {
                    this.success('Service deleted.');
                    this.delete_dialog = false;
                    this.$emit('refresh');
                    this.$emit('exit');
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        },

        emitEdit() {
            if(this.item.id) {
                this.$emit('edit', this.item.id)
            }
        }


    }
}
</script>
